var map = {
	"./CROPROTATION.svg": "5072",
	"./LANDUSEPLANNING-SavannahChappus.svg": "f233",
	"./MANAGEDROTATIONALGRAZING.svg": "5395",
	"./ROLLING_HILLS-AnneDigges.svg": "568e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";